import _styled from "styled-components";
var _excluded = ["style", "className", "maxLength", "onBlur", "onChange", "onFocus", "value"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { useForwardedRef } from '@adsk/alloy-react-helpers';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { CommentInput } from '.';
import CharacterCount from './CharacterCount';
var CommentInputWithCounter = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _inputRef$current;
  var style = _ref.style,
    className = _ref.className,
    maxLength = _ref.maxLength,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  var inputRef = useForwardedRef(ref);
  if (!maxLength || maxLength <= 0) {
    return null;
  }
  var count = ((_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.value.length) || 0;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    className: className,
    $_css: [{
      position: 'relative'
    }]
  }, /*#__PURE__*/React.createElement(CommentInput, _extends({
    ref: inputRef,
    style: [{
      paddingBottom: '36px'
    }, style],
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    value: value,
    maxLength: maxLength
  }, props)), /*#__PURE__*/React.createElement(CharacterCount, {
    count: count,
    maxLength: maxLength,
    style: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      padding: "".concat(theme.spacing.xSmall, "px ").concat(theme.spacing.small, "px")
    }
  }));
});
CommentInputWithCounter.displayName = 'CommentInputWithCounter';
CommentInputWithCounter.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Max number of character allowed in the input */
  maxLength: PropTypes.number.isRequired
};
export default CommentInputWithCounter;
var _StyledDiv = _styled("div").withConfig({
  displayName: "CommentInputWithCounter___StyledDiv",
  componentId: "sc-14mmq94-0"
})(["", ""], function (p) {
  return p.$_css;
});
//# sourceMappingURL=CommentInputWithCounter.js.map